import * as React from 'react'; // export type SizeType = 'small' | 'middle' | 'large' | undefined;

var SizeContext = /*#__PURE__*/React.createContext(undefined); // export interface SizeContextProps {
//   size?: SizeType;
// }

export var SizeContextProvider = function SizeContextProvider(_ref) {
  var children = _ref.children,
      size = _ref.size;
  return /*#__PURE__*/React.createElement(SizeContext.Consumer, null, function (originSize) {
    return /*#__PURE__*/React.createElement(SizeContext.Provider, {
      value: size || originSize
    }, children);
  });
};
export default SizeContext;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-provider/src/SizeContext.js